export const IMAGE_UPLOAD_PATH = "/image/upload"
